import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LangSwitcherComponent } from './lang-switcher.component';
import { TranslationModule } from 'src/app/i18n/translation.module';

@NgModule({
  declarations: [
    LangSwitcherComponent
  ],
  imports: [
    CommonModule,
    TranslationModule
  ],
  exports: [LangSwitcherComponent]
})
export class LangSwitcherModule { }
